import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { CludoSearchResults } from '2-feature/Search/CludoSearchResults';
import { CludoContext, CludoContextConfig } from 'ui/contexts/CludoContext';
import { getEngineId } from '3-foundation/Search/getEngineId';
import { useApplicationContext } from '3-foundation/Application/ApplicationContext';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { useSearchParams } from 'next/navigation';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';
import { getSearchSiteId } from '3-foundation/Search/getSearchSiteId';
import { useRouter } from 'next/router';
import { useSiteContext } from '3-foundation/Site/SiteContext';

export const SearchPage = ({ properties }: { properties: Content.SearchPageProperties }) => {
	const { heading } = properties ?? {};
	const siteContext = useSiteContext();
	const applicationContext = useApplicationContext();
	const { locale } = useRouter();
	const searchParams = useSearchParams();
	const tag = searchParams.get('tag');
	const query = searchParams.get('query');

	const cludoLanguage = locale as 'da' | 'en' | 'kl-gl';
	const cludoConfiguration: CludoContextConfig = {
		customerId: Number(applicationContext.envVars.NEXT_PUBLIC_SEARCH_CLUDO_CLIENT_ID),
		engineId: getEngineId({
			daEngine: applicationContext.envVars.NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_DA as string,
			enEngine: applicationContext.envVars.NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_EN as string,
			klEngine: applicationContext.envVars.NEXT_PUBLIC_SEARCH_CLUDO_ENGINE_KL as string,
			locale: cludoLanguage,
		}),
		siteid: getSearchSiteId(siteContext.root.id),
		locale: cludoLanguage,
		searchTag: tag,
	};

	// Simple validation of Cludo configuration
	if (!cludoConfiguration.customerId || !cludoConfiguration.engineId || !cludoConfiguration.siteid || !cludoConfiguration.locale) {
		return <p>Missing Cludo configuration</p>;
	}

	return (
		<CludoContext config={cludoConfiguration}>
			<CludoComment>
				<MainRegion>
					<CludoSearchResults heading={heading} searchTag={tag} initialQuery={query} />
					<GoToTopNavigation />
				</MainRegion>
			</CludoComment>
		</CludoContext>
	);
};
